
export const environment = {
  production: true,

  firebase: {
  },

  appname: 'Online Quotations',
  baseUrl: 'https://api-dev.quotator360.com', // API Gateway URL
  appUrl: 'https://dev.quotator360.com', // Application URL
  authorityUrl: 'https://auth-dev.quotator360.com', // Identity URL

  smartSuffix: '',
  healthSuffix: '',
  lifeSuffix: '',
  loginUrl: 'authentication/login',
  notify_lifeRoles: ['Life PI UW Manager', 'Life PI UW', 'Life PI Junior UW', 'Life PI Sales'],
  notify_healthRoles: ['Health PI UW Manager', 'Health PI UW', 'Health PI Junior UW', 'Health PI Sales'],
  clientId: 'smart_app_web', //'iq2gateway'// Client Id registered in API
  clientKey: '493876E0-A5BF-4B9C-9608-D2576DA85A62',
  APPINSIGHTS_INSTRUMENTATIONKEY: "7405b1fa-0b9d-4d79-aa09-d1f06ee7e33a",
  Encryption_Key: "Dk21s8l2IxMs5Em6",
  recaptchaSettings: {
    secretKey: "6LfLCLIUAAAAAEUUUDoz7j0HB7ZSovl85I6w4fm6",
    siteKey: "6LfLCLIUAAAAAPbm2_Cf4DVF7DScj8R_cIO28g78",
    version: "v2"
  },
  debug: false,
  log: {
    auth: false,
    store: false,
  },

  smartadmin: {
    api: null,
    db: 'smartadmin-angular'
  }

};

